const mobileAppEvent = (eventName: string) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ eventName }));
  }
};

export default mobileAppEvent;
